import { useTranslation } from 'react-i18next';

import type {
  WebhookDeliveryStatus,
  WebhookEndpointStatus,
} from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const WARNING = 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25';
const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

const DELIVERY: Record<WebhookDeliveryStatus, string> = {
  pending: NEUTRAL,
  retrying: WARNING,
  delivered: SUCCESS,
  failed: DANGER,
};

export function DeliveryStatusBadge({
  status,
  className,
}: {
  status: WebhookDeliveryStatus;
  className?: string;
}) {
  const { t } = useTranslation('webhooks');
  return (
    <Badge variant="outline" className={cn(DELIVERY[status], className)}>
      {t(`deliveryStatus.${status}`)}
    </Badge>
  );
}

export function EndpointStatusBadge({
  status,
  className,
}: {
  status: WebhookEndpointStatus;
  className?: string;
}) {
  const { t } = useTranslation('webhooks');
  return (
    <Badge variant="outline" className={cn(status === 'active' ? SUCCESS : DANGER, className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
